var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8F8FEA;}\n\t.st1{fill:#262626;}\n\t.st2{fill:#C5832D;}\n\t.st3{fill:#D08B30;}\n\t.st4{fill:#D19C57;}\n\t.st5{fill:#FFE5BA;}\n\t.st6{fill:#F9F9F9;}\n\t.st7{fill:#E9E9E8;}\n\t.st8{fill:#45756D;}\n\t.st9{fill:#E6E7E8;}\n\t.st10{fill:#7CCCC3;}\n\t.st11{fill:#FBC781;}\n\t.st12{fill:#313C2C;}\n\t.st13{fill:#946222;}\n\t.st14{fill:#FBB040;}\n\t.st15{fill:#FFFFFF;stroke:#141414;stroke-miterlimit:10;}\n\t.st16{fill:#414042;}\n\t.st17{fill:#F1F2F2;}\n\t.st18{fill:#FDB5AC;}\n\t.st19{fill:#F14950;}\n\t.st20{fill:#FCC066;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 95,
    cy: 101.6,
    r: 92.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.6,185.8l-3.6,8.1c1.5,0.1,2.9,0.2,4.4,0.2c0-3,0-5.8,0-8.3L91.6,185.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "95.8,153.6 95.2,154 95.8,154.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.5,185.8l2.8,0h-0.6v-31.5L75.3,166c0,0-5.5-3.3-6,10.5h15.6c0.1,0,0.1,0,0.2,0h0.3 c0.5,0,0.9,0.2,1.2,0.4c0,0,0.1,0,0.1,0c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.5,0.6,0.5,0.9v0.3v15.4c0.2,0,0.4,0,0.6,0l3.6-8.1 L92.5,185.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.5,178c0-0.3-0.2-0.6-0.5-0.9c0.3,0.3,0.5,0.7,0.5,1.2V178z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.5,178.3c0,1-0.9,1.8-2.1,1.8H45.9c11.1,6.9,23.8,11.5,37.4,13.2c2.2-2.6,0-5.5,0.9-5.1 c0.3,0.2,1.6,2.8,1.6,5.4c0.6,0.1,1.1,0.1,1.7,0.1V178.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.7,176.9C86.7,176.9,86.8,176.9,86.7,176.9C86.8,176.9,86.7,176.9,86.7,176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.1,176.5c-0.1,0-0.1,0-0.2,0H69.3H40.4c0,0,0,0,0,0H85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.5,180.2c1.1,0,2.1-0.8,2.1-1.8c0-0.5-0.2-0.9-0.5-1.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1,0-0.1,0 c-0.4-0.2-0.8-0.4-1.2-0.4h-0.3H40.5c1.8,1.3,3.6,2.5,5.4,3.7H85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.2,188.3c-0.9-0.5,1.3,2.5-0.9,5.1c0.8,0.1,1.7,0.2,2.5,0.3C85.8,191.1,84.5,188.5,84.2,188.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.7,
    y: 79,
    className: "st5",
    width: 9.7,
    height: 11.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.1,174.9l-26.3-20.5l-0.6-0.5l-0.5-0.4v0.7v31.5h0.6l2.8,0c0-1.3,0-2.6,0-3.8l9.3,11.2 c4.6-0.6,9.1-1.6,13.5-2.9C123,176.7,122.1,174.9,122.1,174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98,185.8l0.9,0l-0.2,8.3c3.2-0.2,7-0.6,8.7-0.8L98,182C98,183.2,98,184.4,98,185.8z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M104.4,92.7h-9.2H86l-11.8,6.5c0,0,0.6,31.3,0.6,41.8c0,6.7-6.5,33.9-6.5,33.9h26.9h26.9c0,0-5.9-25-5.9-33.5 c0-9.8,0-42.2,0-42.2L104.4,92.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.7,88c0,0-4.5,0.8-20.5,8.3c0,0,0,0-0.1,0c1.1,1,2.4,6,3.3,13h3c0.3,1.8,0.7,7.9,0.8,14.2 c6.9,3.2,14.5,5,22.6,5c0.1,0,1.6-38.2-6-38L85.7,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M125.5,96.3C125.5,96.3,125.5,96.3,125.5,96.3C125.5,96.2,125.5,96.2,125.5,96.3c-2.3-1.1-18.3-7.9-18.3-7.9 l-6.8,0.7l-5.2,39.4c8.6,0,16.8-2.1,24-5.8c0.1-6.2,0.4-11.9,0.6-13.5h2.1l-1.6-4.3C119.4,99.1,127.6,97.5,125.5,96.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M108.8,130.5c0,0,7.5-0.2,10.4-5.9c1.8-3.7,0.6-15.4,0.6-15.4L108.8,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M81.5,130.5c0,0-7.5-0.2-10.3-5.9c-1.8-3.7,2.3-16.4,2.3-16.4L81.5,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M74.5,128.3c0,0,6.8,3.6,9.3,3.6l-9.2,1.9L74.5,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.1,128.1c0,0-7.8,2.6-10.8,2.7l10.3,4.5L116.1,128.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M95.2,109.6c0,0-6.1,0.3-6.6,0c-0.4-0.3-2.3-9.8-2.3-11.2c0.1-1.5,0.4-6.4,2.3-6.4c1.9,0,15.7-3.7,17.6-0.7 C108.1,94.2,101.6,113.3,95.2,109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M95.2,90.4c-2.4,0.2-4.4,2.1-4.4,2.1c1,2.9,2.5,5.2,2.5,5.2h2h2c0,0,1.5-2.2,2.4-5.2 C99.6,92.6,97.6,90.6,95.2,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.7,85.5l-7.1,2.7l6.6,8.9l6-6.6C95.2,90.4,89.6,89.5,89.7,85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M99.4,85.4L108,88l-6.9,9.1l-6-6.6C95.2,90.4,98.9,89.7,99.4,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M97.1,97.8h-2h-2c-2,6-2.5,47.2-2.5,47.2l4.3,13.5l5.2-13.5C100.3,145,100.1,105.1,97.1,97.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M166.8,74c0,0-1.4-6.7,3.7-10c3.8-2.5,10.9-1.6,12,2.3c1.1,3.9-8.3,13.6-8.3,13.6L166.8,74z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M170.2,76.6c-2.2-1.8-4-3.3-4-3.3c-0.4,1-7.5,16.7-24.1,22.7c-8,2.9-13.7,2.5-28.1-4.9 c-3.7,10.5,0.7,21.7,1.1,24.2c-0.4-2.5,3.8,0,3.8,0s15.8,0.6,27.2-5.7c16.3-9.1,22.6-18,28.3-29.7 C174.2,79.9,173.4,79.2,170.2,76.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M177.8,58.3c0,0-3.7,1-2.7,3.2c1,2.2,4.5,9.1,6.6,8.8c2.1-0.2,5.1-2,2.1-6.3 C181.6,60.7,180.5,57.2,177.8,58.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 148.9,
    y: 23.7,
    transform: "matrix(0.3087 -0.9511 0.9511 0.3087 87.5985 193.3407)",
    className: "st10",
    width: 55.7,
    height: 25.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M194.9,15.5L179.2,64l-20.5-6.7l15.7-48.5L194.9,15.5z M177.9,61.6l14.6-44.8l-16.8-5.5l-14.6,44.8 L177.9,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M172.9,48.6c1.7,0.5,2.7,2.4,2.1,4.1c-0.6,1.7-2.4,2.7-4.1,2.1c-1.7-0.6-2.6-2.4-2.1-4.1 C169.3,49,171.2,48,172.9,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M182.8,18c1.7,0.5,2.7,2.4,2.1,4.1c-0.6,1.7-2.4,2.7-4.1,2.1c-1.7-0.6-2.6-2.4-2.1-4.1 C179.2,18.4,181.1,17.5,182.8,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179.2,29.2c4,1.3,6.2,5.6,4.9,9.6c-1.3,4-5.6,6.2-9.6,4.9c-4-1.3-6.2-5.6-4.9-9.6 C170.9,30.1,175.2,27.9,179.2,29.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 12.7,
    transform: "matrix(0.8679 -0.4968 0.4968 0.8679 1.5463 86.9256)",
    className: "st10",
    width: 25.4,
    height: 55.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M167.5,68.1l-25.3-44.3l18.7-10.7l25.4,44.3L167.5,68.1z M144.8,24.5l23.4,40.9l15.4-8.8l-23.4-40.9 L144.8,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M157.8,29.4c-1.6,0.9-3.5,0.4-4.4-1.2c-0.9-1.6-0.4-3.6,1.2-4.4c1.6-0.9,3.5-0.3,4.4,1.2 C159.9,26.6,159.4,28.6,157.8,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M173.8,57.3c-1.6,0.9-3.6,0.4-4.4-1.2c-0.9-1.6-0.4-3.5,1.2-4.5c1.6-0.9,3.5-0.4,4.4,1.2 C175.9,54.4,175.4,56.4,173.8,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M168,47.2c-3.7,2.1-8.3,0.8-10.4-2.8c-2.1-3.6-0.8-8.3,2.8-10.4c3.6-2.1,8.3-0.8,10.4,2.8 C172.9,40.4,171.6,45.1,168,47.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M166.1,73.3c0,0-2.4-5.8-1.4-8.1c1-2.3,8.8-6.1,9.7-3.4c0.9,2.8-4.3,4.2-5.2,4.7c-0.9,0.5,2.9,2.9,2.5,5.7 c-0.4,2.8-2.5,3.5-2.5,3.5L166.1,73.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.4,168.4H65c2,0,3.7,2,3.7,4.5c0,2.5,0,6.2,0,6.2c2.8,0,2.5-3.9,2.5-7.3c0-3.4-2.3-6.2-5.1-6.2h-7.7 c-2.8,0-5.1,2.8-5.1,6.2c0,3.4-0.3,7.3,2.5,7.3c0,0,0-3.7,0-6.2C55.7,170.5,57.4,168.4,59.4,168.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M57,178.1c0,0.9-0.8,1.6-1.9,1.6h-0.5c-1,0-1.9-0.7-1.9-1.6l0,0c0-0.9,0.8-1.6,1.9-1.6h0.5 C56.2,176.5,57,177.2,57,178.1L57,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M71.6,178.3c0,0.9-0.8,1.6-1.9,1.6h-0.5c-1,0-1.9-0.7-1.9-1.6l0,0c0-0.9,0.8-1.6,1.9-1.6h0.5 C70.8,176.8,71.6,177.5,71.6,178.3L71.6,178.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.6,165.2c-0.7-2.1-1.2-3.6-2.4-5c-1.7,1.2-5,2-6.7,2.3l-0.5,0.2c0,0,0.3,2.3,1.2,5c0.7,2.2,1.3,3.2,3,2.8 C68.9,168.5,67.1,166.7,66.6,165.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M63,162.6c2.8-0.6,3.4-1.7,3.4-1.7c-0.5-0.9-5.5-13.8-3.3-28c1.3-8.4,4.7-16.3,19.5-22.8 c-5.8-9.5-17.4-13.8-17.4-13.8s-9.5,6-12.7,27.4c-2.8,18.5,1.2,33,3.8,39.3C56.3,162.9,59,163.5,63,162.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M131.9,52.6c0,14.3-6.4,33.1-19.7,33.2c-0.7,0-8.5-17.1-15-17.1c-0.9,0-1.9,0.3-2.9,0.9V14.9 C115,14.9,131.9,31.8,131.9,52.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M116.6,63.4c0,0-10.1,24.5-2.1,29c1.2,0.7,5.3,3.9,6.3,2.9c9.4-8.6,2.6-18.5,5.5-23.1 C129.2,67.6,118.9,46.7,116.6,63.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M56.4,52.6c0,14.3,6.4,33.1,19.7,33.2c0.7,0,8.5-17.1,15-17.1c0.9,0,1.9,0.3,2.9,0.9V14.9 C73.3,14.9,56.4,31.8,56.4,52.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M71.7,63.4c0,0,10.1,24.5,2,29c-1.2,0.7-5.2,3.9-6.3,2.9c-9.4-8.6-2.6-18.5-5.5-23.1 C59.1,67.6,69.4,46.7,71.7,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M103.6,28.7c0,0-12.5,18.7-31.7,19.2c0,0-6.2-17,6.3-25c12.5-8,26,0,26,0L103.6,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M103.6,28.7c0,0,9.4,18.9,12.3,20c0,0,4.2-1.9,3.8-7.2c-0.5-5.3-6.1-23-14.9-21.2 C95.9,22.2,102.1,25.7,103.6,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M69.1,103.9c-2.4,0.3-5.3,3.3-4.5,7.6c0.6,3.7,3.5,5.8,4.7,7.6c1.1,1.9,0.1,5.4,0.1,5.4s9.6-7.5,7.3-15.3 C75,103.8,71.6,103.6,69.1,103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M126.8,54.3c0,15.4-14.6,28-32.7,28c-18,0-32.7-12.5-32.7-28c0-15.4,14.6-28,32.7-28 C112.2,26.3,126.8,38.8,126.8,54.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94.1,74.3c7.3,0,10.2-6.3,10.2-11.9H83.9C83.9,68,87.2,74.3,94.1,74.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M74.6,31.8c0,0-3.5,18.2-11.9,24.2C54.3,62,57.1,37.5,74.6,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M72,30.1c0,0,34,23.6,53.1,9.7c2.6-1.9,6.8-7.7,5.9-11.1c0,0-5.9,9.2-21-1.5C101.3,21.1,75.7,20.6,72,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M87.2,48.8c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C85.7,45.5,87.2,46.9,87.2,48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M85.6,48c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4C85,46.6,85.6,47.2,85.6,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M101.1,48.8c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3 C102.6,45.5,101.1,46.9,101.1,48.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 104,
    cy: 48,
    rx: 1.4,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M78.5,60.3c0,2.3-2.3,4.1-5.1,4.1s-5.1-1.8-5.1-4.1s2.3-4.1,5.1-4.1S78.5,58.1,78.5,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M109.8,60.3c0,2.3,2.3,4.1,5.1,4.1c2.8,0,5.1-1.8,5.1-4.1s-2.3-4.1-5.1-4.1C112,56.3,109.8,58.1,109.8,60.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.7,60.3c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C65.7,55.9,67.7,57.9,67.7,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.6,60.3c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5C122.6,55.9,120.6,57.9,120.6,60.3z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M82.9,40c-3.1,0-5.8,1.1-7.1,2.6c0,0,3.3-1.8,7.1-1.8c4,0,7.1,1.8,7.1,1.8C88.7,41.1,86,40,82.9,40z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M68.7,21.9c0,1.3-1,7.1-2.3,7.1c-1.3,0-2.3-5.8-2.3-7.1c0-1.3,1-2.4,2.3-2.4C67.6,19.5,68.7,20.6,68.7,21.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M61.4,23.3c1.1,0.7,5.6,4.6,4.9,5.7c-0.7,1.1-6.2-1-7.3-1.7c-1.1-0.7-1.5-2.1-0.9-3.2 C58.8,23,60.3,22.7,61.4,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M59,30.3c1.2-0.6,6.8-2.4,7.4-1.3c0.6,1.1-4.1,4.8-5.2,5.4c-1.2,0.6-2.6,0.2-3.2-0.9 C57.3,32.3,57.8,30.9,59,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M63.7,36c0.1-1.3,1.4-7.1,2.7-7c1.3,0.1,2,5.9,1.9,7.2c-0.1,1.3-1.2,2.3-2.4,2.3 C64.6,38.4,63.6,37.3,63.7,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M71,34.9c-1.1-0.7-5.3-4.8-4.6-5.9c0.7-1.1,6.1,1.3,7.2,2.1c1.1,0.7,1.4,2.2,0.7,3.2 C73.5,35.4,72.1,35.6,71,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M73.8,28.1c-1.2,0.6-6.9,2.1-7.4,0.9c-0.5-1.2,4.3-4.6,5.5-5.1c1.2-0.6,2.6-0.1,3.1,1.1 C75.5,26.1,75,27.5,73.8,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M68,29c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7C67.3,27.3,68,28.1,68,29z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M75.3,28.7c0,0,8.4-9,23.5-5.3c15.1,3.7,13.6,11.3,23.1,11.1c0,0-13,5.9-22.3-3.8 C90.3,21,75.3,28.7,75.3,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M68.8,89.2c-2.9,0.4-6.4,4-5.5,9.2c0.8,4.5,4.3,7,5.6,9.2c1.4,2.3,0.1,6.5,0.1,6.5s11.6-9,8.8-18.4 C75.9,89.1,71.8,88.8,68.8,89.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M69.5,115.3c-1.8,0.2-3.9,2.5-3.4,5.7c0.5,2.8,2.6,4.3,3.5,5.7c0.8,1.4,0.1,4,0.1,4s7.2-5.6,5.4-11.4 C73.9,115.3,71.4,115.1,69.5,115.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M70.2,129.1c-1.9,0.2-4.1,2.5-3.5,5.9c0.5,2.8,2.7,4.4,3.6,5.9c0.9,1.5,0.1,4.2,0.1,4.2s7.4-5.8,5.6-11.8 C74.7,129,72.1,128.8,70.2,129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M67.7,130.6c0,0-1.8-1.8-0.2-4.2c1-1.6,6.2-1.7,7.1-0.3c1.4,2.1-0.3,4.1-0.3,4.1S70.8,127.4,67.7,130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M119.5,89.2c3,0.4,6.4,4,5.5,9.2c-0.8,4.5-4.3,7-5.6,9.2c-1.4,2.3-0.1,6.5-0.1,6.5s-11.6-9-8.8-18.4 C112.4,89.1,116.5,88.8,119.5,89.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M118.8,115.3c1.8,0.2,3.9,2.5,3.4,5.7c-0.5,2.8-2.6,4.3-3.5,5.7c-0.9,1.4-0.1,4-0.1,4s-7.2-5.6-5.4-11.4 C114.4,115.3,116.9,115.1,118.8,115.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M118.1,129.1c1.9,0.2,4.1,2.5,3.5,5.9c-0.5,2.8-2.7,4.4-3.6,5.9c-0.9,1.5-0.1,4.2-0.1,4.2s-7.4-5.8-5.6-11.8 C113.6,129,116.2,128.8,118.1,129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M120.6,130.6c0,0,1.8-1.8,0.2-4.2c-1-1.6-6.2-1.7-7.1-0.3c-1.4,2.1,0.3,4.1,0.3,4.1S117.5,127.4,120.6,130.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M119.2,103.9c2.4,0.3,5.3,3.3,4.5,7.6c-0.6,3.7-3.5,5.8-4.7,7.6c-1.1,1.9-0.1,5.4-0.1,5.4s-9.6-7.5-7.3-15.3 C113.3,103.8,116.7,103.6,119.2,103.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.b10119bf7a9e17bbc6ff65392f313151.svg";
export { ForwardRef as ReactComponent };